export const mf = "@newsenec/root-config";
export const mfShorty = "RCF";
export const documentTitles = {
    cockpit: "SENEC.Cockpit",
    control: "SENEC.Control",
};
export const roles = {
    technicalService: "Technical_Service",
};
